import {Component, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {FieldConfig} from "../../../interfaces/field.interface";

@Component({
    selector: "app-checkbox",
    template: `
        @if (hideMe != true && field.hideMe != true) {
          <span style="display: block; text-align: left; padding-left: 30px" class="{{field.name}}-dynamic-class">
            <div class="demo-full-width margin-top" [formGroup]="group">
              <mat-checkbox [formControlName]="field.name">{{field.label}}</mat-checkbox>
            </div>
          </span>
        }
        `,
    styles: []
})

export class CheckboxComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    public hideMe = false;

    constructor() {
    }

    ngOnInit() {
    }

    disableInput(i_value) {
        if (i_value){
            this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.group.get(this.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }
}
